import * as React from 'react'
import { useIntl } from 'react-intl'

import IconButton from '../../../../LuxKit/Button/IconButton'
import LineTimesIcon from 'LuxKit/Icons/line/LineTimesIcon'

interface Props extends Omit<React.ComponentProps<typeof IconButton>, 'kind' | 'children'> {
  size?: React.ComponentProps<typeof IconButton>['size']
  variant?: React.ComponentProps<typeof IconButton>['variant']
}

function CloseButton({ size = 'small', variant = 'default', ...props }: Props) {
  const intl = useIntl()
  return <IconButton
    kind="tertiary"
    aria-label={intl.formatMessage({
      id: 'mNe2viA-Izq9U7ViJ2Ry',
      defaultMessage: 'Close',
    })}
    {...props}
    data-testid="close-banner-button"
    size={size}
    variant={variant}
  >
    <LineTimesIcon />
  </IconButton>
}

export default CloseButton
